import React from 'react'
import { Search, Users, Zap } from 'lucide-react'

const Credibility: React.FC = () => {
  const stats = [
    {
      icon: Search,
      number: "10,000+",
      description: "글로벌 게시물 스캔",
      color: "text-purple-500"
    },
    {
      icon: Users,
      number: "15개",
      description: "해외 커뮤니티 분석",
      color: "text-blue-500"
    },
    {
      icon: Zap,
      number: "100+",
      description: "자체 분석 정교화 기능",
      color: "text-green-500"
    }
  ]

  return (
    <section className="py-20 bg-gray-900 text-white relative overflow-hidden">
      {/* 배경 장식 */}
      <div className="absolute top-0 left-0 w-full h-full">
        <div className="absolute top-20 left-10 w-64 h-64 bg-primary-500/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-80 h-80 bg-purple-500/10 rounded-full blur-3xl"></div>
      </div>

      <div className="container-width section-padding relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            매주 <span className="text-primary-400">이만큼</span> 분석합니다
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            단순한 번역이나 요약이 아닌, <strong className="text-white">체계적인 데이터 분석</strong>을 통해
            <br />
            정말 중요한 AI 트렌드만을 선별해 전달합니다
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {stats.map((stat, index) => (
            <div 
              key={index}
              className="text-center group animate-slide-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className={`w-20 h-20 ${stat.color} bg-current/10 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <stat.icon className={`w-10 h-10 ${stat.color}`} />
              </div>
              
              <div className={`text-5xl md:text-6xl font-bold ${stat.color} mb-4`}>
                {stat.number}
              </div>
              
              <p className="text-lg text-gray-300 font-medium">
                {stat.description}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-primary-600/20 to-purple-600/20 p-8 rounded-3xl border border-primary-500/30 backdrop-blur-sm">
          <div className="text-center">
            <h3 className="text-2xl md:text-3xl font-bold mb-4">
              🔍 <span className="text-primary-400">AI 전문가 수준</span>의 큐레이션
            </h3>
            <p className="text-lg text-gray-300 max-w-4xl mx-auto leading-relaxed">
              Reddit, Hacker News, GitHub, Twitter 등 글로벌 개발자 커뮤니티에서 
              <strong className="text-white"> 실제로 화제가 되는 AI 혁신</strong>만을 엄선해 
              <strong className="text-primary-400"> 한국어로 완벽 번역</strong>하여 제공합니다
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Credibility
